export default __webpack_public_path__ + "87a93606013db1109dcb34986cceb39b.coffee";